<template>
  <v-container>
    <back-button :label="trans('guest.guests')" fallback-route="Guests"></back-button>

    <request-state :request-promise="guestRequest" :retry-action="getGuest">
      <template v-if="guest">
        <page-heading>{{ pageTitle }}</page-heading>

        <guest-card :guest="guest" show-id class="mt-3" />

        <v-card class="mt-3">
          <v-card-title>
            {{ trans('bankAccount.bankDetails') }}
          </v-card-title>

          <v-card-text>
            <form-input
              v-if="guest.bankAccount && guest.bankAccount.bankBlz"
              :label="trans('bankAccount.blz')"
              :value="guest.bankAccount.bankBlz"
              cols="3"
              readonly
            />

            <form-input
              v-if="guest.bankAccount && guest.bankAccount.bankName"
              :label="trans('bankAccount.bankName')"
              :value="guest.bankAccount.bankName"
              cols="3"
              readonly
            />

            <form-input
              v-if="guest.bankAccount && guest.bankAccount.bankAcc"
              :label="trans('bankAccount.accountNumber')"
              :value="guest.bankAccount.bankAcc"
              cols="3"
              readonly
            />

            <form-input
              :label="trans('bankAccount.owner')"
              :value="guest.bankAccount ? guest.bankAccount.bankOwner : ''"
              cols="3"
              readonly
            />

            <form-input
              :label="trans('bankAccount.bic')"
              :value="guest.bankAccount ? guest.bankAccount.bankSwift : ''"
              cols="3"
              readonly
            />

            <form-input
              :label="trans('bankAccount.iban')"
              :value="guest.bankAccount ? guest.bankAccount.bankIban : ''"
              cols="3"
              readonly
            />
          </v-card-text>
        </v-card>

        <v-card class="mt-3">
          <v-card-title>
            {{ transPlural('booking.booking') }}
          </v-card-title>

          <v-card-text>
            <ajax-table
                ref="bookingsTable"
                :resource="resourceUrl + '/' + this.guest.id + '/bookings'"
                :headers="[
                  {text: 'booking.bookingId', value: 'id'},
                  {text: 'booking.status', value: 'status'},
                  {text: 'booking.bookingDate', value: 'bookingDate'},
                  {text: 'object.object', value: 'objectName'},
                  {text: 'booking.checkinAt', value: 'checkinAt'},
                  {text: 'booking.checkoutAt', value: 'checkoutAt'},
                  {text: 'guest.guests', value: 'guests'},
                  {text: 'booking.rent', value: 'totalWithoutDepositAndBookingFee', type: 'currency'}
                ]"
                :page-options="{itemsPerPage: 20}"
                :items-per-page-options="[10, 20, 50, 100]"
                no-elevation
            >
              <template v-slot:item.id="{ item }">
                <booking-id :value="item"/>
              </template>

              <template v-slot:item.status="{ item }">
                <status-badge v-if="item.disabled" color="red lighten-3">{{ trans('general.deleted') }}</status-badge>
                <booking-status v-else :value="item.status"/>
              </template>

              <template v-slot:item.objectName="{ item }">
                <object-name :value="item" />
              </template>

              <template v-slot:item.guests="{ item }">
                <booking-guests-summary :booking="item"></booking-guests-summary>
              </template>
            </ajax-table>
          </v-card-text>
        </v-card>
      </template>
    </request-state>
  </v-container>
</template>

<script>
import {GuestApi} from "@/api/guest-api";
import BackButton from '@/components/BackButton';
import {MainUtils} from "@/utils/main-utils";
import {RouterUtils} from "@/utils/router-utils";
import {LocaleUtils} from "@/utils/locale-utils";
import PageHeading from "@/components/PageHeading";
import RequestState from "@/components/RequestState";
import FormInput from "@/components/FormInput";
import BookingId from "@/components/BookingId";
import StatusBadge from "@/components/StatusBadge";
import BookingStatus from "@/components/BookingStatus";
import {DateUtils} from "@/utils/date-utils";
import AjaxTable from "@/components/AjaxTable";
import ObjectName from "@/components/ObjectName";
import BookingGuestsSummary from '@/components/BookingGuestsSummary';
import GuestCard from '@/components/GuestCard';

export default {
  name: "GuestDetailsPage",
  mixins: [
    MainUtils,
    RouterUtils,
    LocaleUtils,
    DateUtils
  ],
  components: {
    GuestCard,
    BookingGuestsSummary,
    PageHeading,
    BackButton,
    RequestState,
    FormInput,
    BookingId,
    StatusBadge,
    BookingStatus,
    AjaxTable,
    ObjectName
  },
  props: ['guestId'],
  data: () => ({
    guestRequest: null,
    guest: {updated: false}
  }),
  computed: {
    resourceUrl () {
      return GuestApi.apiUri;
    },
    pageTitle () {
      if (this.guest) {
        return this.trans('guest.guest') + ' ' + this.guest.fullName;
      }
      return null;
    }
  },
  methods: {
    getGuest() {
      this.guestRequest = GuestApi.getById(this.guestId)
        .then(response => {
          this.guest = response.data;
        })
    },
  },
  mounted() {
    if (this.guestId) {
      this.getGuest();
    }
  },
}
</script>

<style scoped>
</style>
